import React from 'react';
import { FormattedMessage } from 'react-intl';

import { Button } from 'antd';

interface LoginLinkProps {
  oauthUri: string;
}

const LoginLink: React.FC<LoginLinkProps> = ({ oauthUri }) => (
  <a href={oauthUri}>
    <Button type="primary">
      <FormattedMessage defaultMessage="Open DATEV Login" />
    </Button>
  </a>
);

export default LoginLink;
